import './Bar.css';

interface BarProps {
  rating: number;
}

export default function Bar({ rating }: BarProps): JSX.Element {
  const height = 5;
  const baseRating = 5.0;
  const fillWidth = Math.round((rating / baseRating) * 100);

  return (
    <span className="acommodation-review-bar">
      <svg
        width="100%"
        height="9px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g>
            <rect
              className="acommodation-review-bar__background"
              x="0"
              y="0"
              width="100%"
              height={height}
              rx="2"
            />
            <rect
              className="acommodation-review-bar__indicator"
              x="0"
              y="0"
              width={`${fillWidth}%`}
              height={height}
              rx="2"
            />
          </g>
        </g>
      </svg>
    </span>
  );
}
